import { useEffect, useState } from "react";

const COLORS = ["#FF69B4", "#FFD700", "#40E0D0", "#9B59B6", "#FFA500", "#87CEEB", "#4CAF50"];

export default function Confetti({ count = 80 }) {
  const [pieces, setPieces] = useState([]);
  useEffect(() => {
    const arr = Array.from({ length: count }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      color: COLORS[i % COLORS.length],
      duration: 2.5 + Math.random() * 2,
      delay: Math.random() * 0.8,
      size: 8 + Math.random() * 8,
    }));
    setPieces(arr);
  }, [count]);

  return (
    <div className="pointer-events-none fixed inset-0 z-50 overflow-hidden" aria-hidden="true">
      {pieces.map((p) => (
        <span
          key={p.id}
          className="confetti-piece"
          style={{
            left: `${p.left}%`,
            backgroundColor: p.color,
            width: p.size,
            height: p.size,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
          }}
        />
      ))}
    </div>
  );
}
